import React from 'react';
export const Footer = (props) => {
	let date = new Date();
	let year = date.getFullYear();
	return (
		<footer>
			<span className='copyright'>
				&copy; {year} | tjonesdev &#10084;
			</span>
		</footer>
	);
};
